import React, { useState } from 'react';
import Vacancy from './Vacancy';
import { useNavigate } from 'react-router-dom';

const Home = () => {
    const[vacancy,setVacancy] = useState(false);
    const navigate = useNavigate();

    const handleButtonClick = () => {
        navigate('/vacancy');
    }
  return (
    <div className="relative h-screen flex items-center justify-center bg-gray-900 text-white overflow-hidden">
      {/* Background image and overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <img
          src="https://static.vecteezy.com/system/resources/previews/017/026/536/non_2x/orange-and-yellow-realistic-3d-megaphone-illustration-on-purple-background-loudspeaker-concept-of-join-us-job-vacancy-and-announcement-in-modern-flat-cartoon-style-design-vector.jpg"
          alt="Background"
          className="w-full object-cover"
        />
      </div>
      <div className="relative z-10 text-center px-4">
        <h1 className="text-5xl font-bold mb-4">We help you to find your Job</h1>
        <p className="text-xl mb-8">
          Here at <span className="font-semibold">FindJobs</span> we focus to find your job that fit on your best experience.
        </p>
        <div className="flex justify-center space-x-4">
          <button onClick={handleButtonClick} 
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded">
            Get started to find Jobs→
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;